import "flatpickr/dist/themes/material_blue.css";
import {
  GET_ROLE_DATA,
  SAVE_ROLE,
  DELETE_ROLE,
} from "../../../helpers/url_api_constant";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  FormGroup,
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Modal,
  Row,
  Table,
} from "reactstrap";
import ConfirmDialog, {
  useConfirmDialog,
} from "../../../components/Custom/ConfirmDialog";
import MessageDialog, {
  useModalShowMessage,
} from "../../../components/Custom/MessageDialog";
import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Loading from "../../../components/Custom/Loading";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { post } from "../../../helpers/api_helper";
//i18n
import { withTranslation } from "react-i18next";
import "../../../assets/scss/datatables.scss";
import { Link, useHistory } from "react-router-dom";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";

function RoleManagement(props) {
  //การกด link ไปหน้าอื่น //
  let history = useHistory();
  //การกด link ไปหน้าอื่น //
  const permission = getPermission();
  const searchObj = { ROLE_NAME: "", ROLE_DESC: "" };
  const createObj = { PID: "", ROLE_NAME: "", ROLE_DESC: "" };

  const [readonly, setReadonly] = useState(false)
  const [pageAdd, setPageAdd] = useState(false);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);
  const [userActionType, setUserActionType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const {
    showMessage,
    toggleModalMessage,
    bodyMessageModal,
    titleMessageModal,
  } = useModalShowMessage();
  const { showConfirm, toggleConfirm, messageConfirm } = useConfirmDialog();

  //ฝั่งซ้ายคือ ตัวแปล ฝั่งขวา คือ ฟังก์ชั่น Ex  modelDeviceList เป็น ตัวแปลที่ใช้ ส่วน  setModelDeviceListเป็น ฟังก์ชั่นที่ใช้ Set Value ให้ modelDeviceList

  const listData = [
    {
      PID: 1,
      ROLE_NAME: "System Admin"
    },
    {
      PID: 2,
      ROLE_NAME: "Operator"
    },
    {
      PID: 3,
      ROLE_NAME: "Viewer"
    },
  ];

  //sort Column//
  const defaultSorted = [
    {
      dataField: "PRIORITY_FLAG",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "250",
        value: 250,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    return (
      <div>
        {permission.eRMN && (
          <OverButton
            onClick={() => {
              gotoPageRoleDetail(row);
              // setReadonly(false);
              // onEdit(row);
              // setUserActionType("(Edit)");
            }}
            color="info"
            icon="far fa-edit"
            label="Edit"
          />
        )}
      </div>
    );
  };

  const gotoPageRoleDetail = row => {
    // console.log(row);
    history.push("/role-management/" + row.PID + "/role-management-detail");
  };

  // Action Button//

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  //headerColumn
  const columns = [
    {
      dataField: "PRIORITY_FLAG",
      text: "No.",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
      sort: true,
      // formatter: CountIndexRow,
    },
    {
      dataField: "ROLE_NAME",
      text: "Role Name",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: false,
    },
    {
      dataField: "ROLE_DESC",
      text: "Description",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "25%",
        fontSize: "12px",
      },
      style: {
        width: "25%",
        fontSize: "12px",
      },
      sort: false,
    },
    {
      dataField: "df1",
      text: "Action",
      headerAlign: "center",
      align: "center",
      isDummyField: true,
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
      formatter: ButtonAction,
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    resetSearch();
    resetModel();


    ///fixed header table
    let tableId = "role-management-table";
    let scrollY = 155;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//

  //Function CURL
  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
  };

  const resetModel = () => {
    setCreateModel(createObj);
  };

  const onSearch = () => {
    fetchData(searchModel);
  };

  const onAdd = () => {
    setReadonly(false);
    resetModel();
    setPageAdd(true);
    setUserActionType("(Add Record)");
  };

  const onEdit = row => {
    setCreateModel(row);
    setPageAdd(true);
  };

  const onDelete = row => {
    setCreateModel(row);
    toggleConfirm("Do you want to delete ?");
  };

  const validateForm = () => {
    let bResult = true;
    if (createModel.FULL_NAME == "") {
      bResult = false;
    }

    if (createModel.CONTACT_CODE == "") {
      bResult = false;
    }
    return bResult;
  };

  // อันนี้เขียนแบบ async , await
  const fetchData = async (searchData) => {
    setIsLoading(true);
    try {
      let res = await post(GET_ROLE_DATA, searchData);
      // console.log(res);
      setModelDeviceList(res.data.roleList);
      // setModelDeviceList(listData);
    } catch (err) {
      toggleModalMessage(err.message);
    }
    setIsLoading(false);
  };

  const saveData = async () => {
    if (validateForm()) {
      setIsLoading(true);
      try {
        let res = await post(SAVE_ROLE, createModel);
        // console.log(res);
        if (res.resultCode == 200) {
          res.isEditMode == 0 ? toggleModalMessage("Save success.") : toggleModalMessage("Update success.");
          setPageAdd(false);
          fetchData(searchModel);
        } else {
          toggleModalMessage(res.resultDescription);
        }
      } catch (err) {
        toggleModalMessage(err.message);
      }
      setIsLoading(false);
    }
  };

  const deleteData = async () => {
    setIsLoading(true);
    try {
      let res = await post(DELETE_SHIPPER, createModel);
      toggleConfirm();
      if (res.resultCode == 200) {
        toggleModalMessage("Delete success.");
        fetchData(searchModel);
      } else {
        toggleModalMessage(res.message);
      }
      setIsLoading(false);
    } catch (err) {
      toggleConfirm();
      toggleModalMessage(err.message);
      setIsLoading(false);
    }
  };

  //Function CURL

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {props.t("Role Management")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            User Management
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Role Management</li>
                      </ol>
                    </div>
                  </div>
                  <hr />
                  <Row>
                    <Col sm="4">
                      <FormGroup className="row mt-0">
                        <div className="search-box">
                          <div className="position-relative">
                            <input
                              type="text"
                              // style={{backgroundColor:"#FFFFFF"}}
                              className="form-control rounded-2 basicborder"
                              placeholder={props.t("Search Role Name")}
                              onChange={(e) =>
                                setSearchModel({
                                  ...searchModel,
                                  ROLE_NAME: e.target.value
                                })
                              }
                              value={searchModel.ROLE_NAME}
                            />
                            <i className="bx bx-search-alt search-icon" />
                          </div>
                        </div>
                      </FormGroup>
                    </Col>

                    <Col sm="8">
                      <div className="d-grid gap-2 d-md-block">
                        <Button color="info" className="mt-0"
                          onClick={() => onSearch()}>
                          <i className="fas fa-search"></i>
                          &nbsp; Search
                        </Button>

                        <Button color="warning" className="mt-0 ms-2"
                          onClick={() => resetSearch()}>
                          <i className="fas fa-redo-alt"></i>
                          &nbsp; Reset
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  {/* <Row className="mb-2">
                    <Col sm="3">
                      <div className="d-grid gap-2 d-md-block">
                        <Button
                          onClick={() => onAdd()}
                          // className="btn-rounded"
                          color="success"
                          className="mt-4 mb-2"
                        >
                          <i className="fas fa-plus"></i>
                          &nbsp; Add
                        </Button>
                      </div>
                    </Col>
                  </Row> */}
                  <Row>
                    <Col sm="12" className="mt-3">
                      <div>
                        {/* className="table-responsive" */}
                        <BootstrapTable
                          id="role-management-table"
                          keyField="PID"
                          data={modelDeviceList}
                          columns={columns}
                          headerClasses="header-style"
                          rowStyle={rowStyleFontWhite}
                          defaultSorted={defaultSorted}
                          pagination={paginationFactory(options)}
                        // hover
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/*start : ModalPageAdd */}
      <Modal size="lg" isOpen={pageAdd}>
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            Shipper {userActionType}
          </h5>
        </div>
        <div className="modal-body">
          <CardBody>
            <AvForm className="needs-validation">
              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    className="col-sm-3 col-form-label text-center"
                  >
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Shipper Name
                  </Label>
                  <Col sm={8}>
                    <AvField
                      // style={{ border: "solid 1px #FFFFFF" }}
                      // readOnly={readonly}
                      disabled={readonly}
                      name="FULL_NAME"
                      type="text"
                      errorMessage="Enter Shipper Name"
                      className="form-control basicborder"
                      validate={{ required: { value: true } }}
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          FULL_NAME: e.target.value,
                        })
                      }
                      value={createModel.FULL_NAME}
                    />
                  </Col>
                </FormGroup>
              </Row>
              <Row>
                <FormGroup className="row mb-3">
                  <Label className="col-sm-3 col-form-label text-center">
                    <span style={{ color: "#FF0E03" }}>* </span>
                    Shipper Code
                  </Label>
                  <Col sm={8}>
                    <AvField
                      // style={{ border: "solid 1px #FFFFFF" }}
                      // readOnly={readonly}
                      disabled={readonly}
                      name="CONTACT_CODE"
                      type="text"
                      errorMessage="Enter Shipper Code"
                      className="form-control basicborder"
                      validate={{ required: { value: true } }}
                      onChange={e =>
                        setCreateModel({
                          ...createModel,
                          CONTACT_CODE: e.target.value,
                        })
                      }
                      value={createModel.CONTACT_CODE}
                    />
                  </Col>
                </FormGroup>
              </Row>
              <div className="text-center mt-2">
                {!readonly &&
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    onClick={() => saveData()}
                  >
                    <i className="far fa-save"></i> Save
                  </button>
                }
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setPageAdd(false)}
                >
                  <i className="fas fa-times"></i> Close
                </button>
              </div>
            </AvForm>
          </CardBody>
          {createModel.PID && (
            <Row className="mt-2">
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-start"
                  style={{ color: "#556ee6" }}
                >
                  Create By : {createModel.CREATE_USER} (  {moment(createModel.CREATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )
                </span>
              </Col>
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-end"
                  style={{ color: "#556ee6" }}
                >
                  Update By :  {createModel.UPDATE_USER} (  {moment(createModel.UPDATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )

                </span>
              </Col>
            </Row>
          )}
        </div>
        {/* -- Model Footer-- */}
        {/* <div className="modal-footer">
                <button type="button" className="btn btn-success">Save</button>
                <button type="button" className="btn btn-light" onClick={() =>
                  this.setState({ modal_backdrop: false })
                }>Close</button>
              </div> */}
        {/* -- Model Footer-- */}
      </Modal>
      {/*end : PageAdd */}

      {/*Loading */}
      <Loading show={isLoading} />
      {/*Loading */}

      {/* MessageDialog */}
      <MessageDialog
        isOpen={showMessage}
        hide={toggleModalMessage}
        title={titleMessageModal}
        message={bodyMessageModal}
      />
      {/* comfirmDialog */}
      <ConfirmDialog
        isOpen={showConfirm}
        hide={toggleConfirm}
        message={messageConfirm}
        onConfirm={deleteData}
      />
    </React.Fragment>
  );
}

RoleManagement.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ RoleManagement }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(RoleManagement));

// function RenderList(prop) {
//   console.log(prop);

//   return (<tr>
//     <td>{prop.indexlist}</td>
//     <td>{prop.data.MeterPointID}</td>
//     <td>{prop.data.Customer}</td>
//     <td>{prop.data.CustomerType}</td>
//     <td>{prop.data.CommunicationType}</td>
//     <td>{prop.data.Zone}</td>
//     <td>{prop.data.Point}</td>
//     <td>{prop.data.Region}</td>
//     <td>{prop.data.Area}</td>
//     <td>{prop.data.BVZoning}</td>
//     <td>{prop.data.BV}</td>
//     <td>
//       <Button className="me-1"
//         onClick={() =>
//           setPageAdd(true)
//         }
//         color="info"
//       >
//         <i className="far fa-edit"></i>
//         &nbsp; Edit
//       </Button>
//       <Button
//         onClick={() =>
//           setModalDelete(true)
//         }
//         // className="btn-rounded"
//         color="danger"
//       >
//         <i className="fas fa-trash-alt"></i>
//         &nbsp; Delete
//       </Button>
//     </td>
//   </tr>)
// }
